var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeng2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 236,
    viewBox: "0 0 288 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 4,
    fill: "url(#paint0_radial_694_1033)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 44,
    r: 4,
    fill: "url(#paint1_radial_694_1033)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter2_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 62,
    r: 4,
    fill: "url(#paint2_radial_694_1033)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 80,
    r: 4,
    fill: "url(#paint3_radial_694_1033)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter4_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 98,
    r: 4,
    fill: "url(#paint4_radial_694_1033)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 116,
    r: 4,
    fill: "url(#paint5_radial_694_1033)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter6_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 134,
    r: 4,
    fill: "url(#paint6_radial_694_1033)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 152,
    r: 4,
    fill: "url(#paint7_radial_694_1033)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter8_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 170,
    r: 4,
    fill: "url(#paint8_radial_694_1033)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 190,
    r: 4,
    fill: "url(#paint9_radial_694_1033)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter10_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 209,
    r: 4,
    fill: "url(#paint10_radial_694_1033)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 212,
    r: 4,
    fill: "url(#paint11_radial_694_1033)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter12_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 212,
    r: 4,
    fill: "url(#paint12_radial_694_1033)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 212,
    r: 4,
    fill: "url(#paint13_radial_694_1033)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter14_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 212,
    r: 4,
    fill: "url(#paint14_radial_694_1033)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 212,
    r: 4,
    fill: "url(#paint15_radial_694_1033)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter16_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 212,
    r: 4,
    fill: "url(#paint16_radial_694_1033)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 212,
    r: 4,
    fill: "url(#paint17_radial_694_1033)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter18_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 212,
    r: 4,
    fill: "url(#paint18_radial_694_1033)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 187,
    cy: 212,
    r: 4,
    fill: "url(#paint19_radial_694_1033)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter20_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 212,
    r: 4,
    fill: "url(#paint20_radial_694_1033)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 223,
    cy: 212,
    r: 4,
    fill: "url(#paint21_radial_694_1033)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter22_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 212,
    r: 4,
    fill: "url(#paint22_radial_694_1033)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 209,
    r: 4,
    fill: "url(#paint23_radial_694_1033)"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter24_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 190,
    r: 4,
    fill: "url(#paint24_radial_694_1033)"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 171,
    r: 4,
    fill: "url(#paint25_radial_694_1033)"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter26_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 153,
    r: 4,
    fill: "url(#paint26_radial_694_1033)"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 135,
    r: 4,
    fill: "url(#paint27_radial_694_1033)"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter28_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 117,
    r: 4,
    fill: "url(#paint28_radial_694_1033)"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 99,
    r: 4,
    fill: "url(#paint29_radial_694_1033)"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter30_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 81,
    r: 4,
    fill: "url(#paint30_radial_694_1033)"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 63,
    r: 4,
    fill: "url(#paint31_radial_694_1033)"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter32_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 45,
    r: 4,
    fill: "url(#paint32_radial_694_1033)"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 24,
    r: 4,
    fill: "url(#paint33_radial_694_1033)"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter34_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 24,
    r: 4,
    fill: "url(#paint34_radial_694_1033)"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 24,
    r: 4,
    fill: "url(#paint35_radial_694_1033)"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter36_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 24,
    r: 4,
    fill: "url(#paint36_radial_694_1033)"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter37_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 24,
    r: 4,
    fill: "url(#paint37_radial_694_1033)"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter38_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 24,
    r: 4,
    fill: "url(#paint38_radial_694_1033)"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter39_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 24,
    r: 4,
    fill: "url(#paint39_radial_694_1033)"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter40_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 24,
    r: 4,
    fill: "url(#paint40_radial_694_1033)"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter41_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 24,
    r: 4,
    fill: "url(#paint41_radial_694_1033)"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter42_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 24,
    r: 4,
    fill: "url(#paint42_radial_694_1033)"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter43_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 24,
    r: 4,
    fill: "url(#paint43_radial_694_1033)"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter44_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 244,
    cy: 24,
    r: 4,
    fill: "url(#paint44_radial_694_1033)"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter45_d_694_1033)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 263,
    cy: 27,
    r: 4,
    fill: "url(#paint45_radial_694_1033)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_694_1033",
    x: 2,
    y: 2,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_694_1033",
    x: 10,
    y: 30,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_694_1033",
    x: 0,
    y: 38,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_694_1033",
    x: 10,
    y: 66,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_694_1033",
    x: 0,
    y: 74,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_694_1033",
    x: 10,
    y: 102,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_694_1033",
    x: 0,
    y: 110,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_694_1033",
    x: 10,
    y: 138,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_694_1033",
    x: 0,
    y: 146,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_694_1033",
    x: 10,
    y: 176,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_694_1033",
    x: 1,
    y: 185,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_694_1033",
    x: 29,
    y: 198,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_694_1033",
    x: 37,
    y: 188,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_694_1033",
    x: 65,
    y: 198,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_694_1033",
    x: 73,
    y: 188,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_694_1033",
    x: 101,
    y: 198,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_694_1033",
    x: 109,
    y: 188,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_694_1033",
    x: 137,
    y: 198,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_694_1033",
    x: 145,
    y: 188,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_694_1033",
    x: 173,
    y: 198,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_694_1033",
    x: 181,
    y: 188,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_694_1033",
    x: 209,
    y: 198,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_694_1033",
    x: 218,
    y: 188,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_694_1033",
    x: 249,
    y: 195,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_694_1033",
    x: 240,
    y: 166,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_d_694_1033",
    x: 250,
    y: 157,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_d_694_1033",
    x: 240,
    y: 129,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_d_694_1033",
    x: 250,
    y: 121,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_d_694_1033",
    x: 240,
    y: 93,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_d_694_1033",
    x: 250,
    y: 85,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_d_694_1033",
    x: 240,
    y: 57,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_d_694_1033",
    x: 250,
    y: 49,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_d_694_1033",
    x: 240,
    y: 21,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_d_694_1033",
    x: 30,
    y: 10,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_d_694_1033",
    x: 38,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_d_694_1033",
    x: 66,
    y: 10,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_d_694_1033",
    x: 74,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_d_694_1033",
    x: 102,
    y: 10,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_d_694_1033",
    x: 110,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_d_694_1033",
    x: 138,
    y: 10,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_d_694_1033",
    x: 146,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter41_d_694_1033",
    x: 174,
    y: 10,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter42_d_694_1033",
    x: 182,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter43_d_694_1033",
    x: 210,
    y: 10,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter44_d_694_1033",
    x: 220,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter45_d_694_1033",
    x: 249,
    y: 13,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.6667 24.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6667 42.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6667 60.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6667 78.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6667 96.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6667 114.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6667 132.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6667 150.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6667 168.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6667 188.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.6667 207.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.6667 210.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.6667 210.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.6667 210.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.6667 210.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.667 210.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.667 210.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(149.667 210.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(167.667 210.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.667 210.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(203.667 210.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(221.667 210.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240.667 210.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(261.667 207.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(262.667 188.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(262.667 169.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(262.667 151.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(262.667 133.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(262.667 115.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(262.667 97.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(262.667 79.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(262.667 61.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(262.667 43.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.6667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.6667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.6667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.6667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(150.667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(168.667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(186.667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(204.667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(222.667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(242.667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_694_1033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(261.667 25.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeng2);
export default __webpack_public_path__ + "static/media/deng2.78fb3055bf761f3ac5f68a32d05a298c.svg";
export { ForwardRef as ReactComponent };